'use client';

import React, { useEffect, useState } from 'react';

import cn from '@/helpers/utils/classNames';

interface SwicthProps {
  value: boolean;
  loading: boolean;
  onChange: () => void;
}

const Swtich = ({ value, loading, onChange }: SwicthProps) => {
  const [isActive, setIsActive] = useState(value);
  useEffect(() => {
    if (!loading && value !== isActive) {
      setIsActive(value);
    }
  }, [loading, value]);

  const handleChange = () => {
    if (!loading) {
      setIsActive(!value);
      onChange();
    }
  };

  return (
    <>
      <div className="v2-flex v2-rounded v2-border v2-border-[#D0D5DD] v2-overflow-auto v2-divide-x v2-divide[#D0D5DD] v2-w-fit">
        <Button
          active={!isActive}
          disabled={isActive}
          onClick={handleChange}
          label="EZShip Recurring"
          isLoading={loading}
        />
        <Button
          active={isActive}
          disabled={!isActive}
          isLoading={loading}
          onClick={handleChange}
          label="One Time Purchase"
        />
      </div>
    </>
  );
};

export default Swtich;

const Button = ({
  active,
  label,
  isLoading,
  disabled,
  onClick,
}: {
  active: boolean;
  isLoading: boolean;
  disabled: boolean;
  label: string;
  onClick: () => void;
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'v2-py-[10px] v2-px-2 md:v2-px-[16px] v2-font-sweet-sans-pro-medium v2-text-[#667085] v2-bg-[#F9FAFB] sm:v2-text-sm v2-border-0 v2-text-xs v2-transition-all hover:v2-bg-[#E2E8E6] active:v2-bg-[#C5D1CC] active:v2-text-[#154734]',
        {
          '!v2-bg-[#154734] !v2-text-white': !active,
        },
        { 'loading-animation': !active && isLoading }
      )}
      disabled={isLoading || disabled}
    >
      {label}
    </button>
  );
};
